import React, {useEffect, useRef, useState} from 'react';
import './GetAQuoteProduct.scss';
import {useNavigate, useParams} from 'react-router-dom';
import {getProductFromProductList} from '../../../firebase/products.store';
import Button from '../../Button/Button';
import {CheckCircleIcon, PaperAirplaneIcon, ShoppingBagIcon} from '@heroicons/react/24/solid';
import {sendEmail} from '../../../firebase/message.store';
import {ROUTES} from '../../../constants/routes';

const GetAQuoteProduct = () => {

  const nameRef = useRef();
  const emailRef = useRef();

  const params = useParams();
  const navigate = useNavigate();

  const [productId, setProductId] = useState('');
  const [product, setProduct] = useState(undefined);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);


  const fetchProduct = async (id) => {
    const product = await getProductFromProductList(id);
    if (product) {
      setProduct(product);
    }
  };

  useEffect(() => {
    setProductId(params.pId);
    fetchProduct(params.pId);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const name = nameRef.current.value;
    const email = emailRef.current.value;

    if (name && email && product) {
      await sendEmail(
          {
            from: ['Karmit Patel <karmit199@gmail.com>'],
            to: [`hiren@weightechsolutions.ca`],
            replyTo: [email],
            message: {
              subject: `${name} wants a quote!`,
              html: `
	  	  From: <h2>${email}</h2>
	  	  <br>
	  	  Name: <h2>${name}</h2>
	  	  <br>
	  	  Product: <h3>${product.name} quote required! - ID: ${productId}<h3>`
            }
          }
      );

      setShowSuccessMessage(true);
      e.target.reset();
    }
  };


  const handleRedirectToProducts = () => {
    navigate(ROUTES.PRODUCTS);
  };

  return (
      <>
        <section className='contact-forms'>
          {!showSuccessMessage && product ? (
              <>
                <h1 className={'title'}>Get a Quote</h1>
                <h3 className={'subTitle'}>Fill out the form below to receive a personalized quote for this product</h3>
                <br/>
                <form onSubmit={handleSubmit} className='form-container'>
                  <div className='form-section'>
                    <div className='image-container'>
                      <img src={product.thumbnail.url} alt={product.thumbnail.name}/></div>
                  </div>
                  <div className='form-section'>
                    <h2 className='product-name'>{product.name}</h2>
                    <fieldset name={'name'}>
                      <label htmlFor='name'>Name *</label>
                      <input
                          type='text' name='name' id='name' placeholder={'Enter your name'}
                          autoComplete={'given-name family-name'}
                          required={true}
                          ref={nameRef}
                      />
                    </fieldset>
                    <fieldset name={'email'}>
                      <label htmlFor='email'>Email *</label>
                      <input
                          type='email' name='email' id='email' placeholder={'Enter your email'}
                          autoComplete={'email'}
                          required={true}
                          ref={emailRef}
                      />
                    </fieldset>
                    <div className='action-bar right full'>
                      <Button className={'solid primary'} type={'submit'}>
                        Get a Quote
                        <PaperAirplaneIcon className={'heroicon-24'}/>
                      </Button>
                    </div>
                  </div>

                </form>
              </>
          ) : (
              <div className='success-message'>
                <div className='success-icon'>
                  <CheckCircleIcon className={'heroicon-48'}/>
                </div>
                <h1 className={'title'}>Quote Request Sent Successfully!</h1>
                <h3 className={'subTitle'}>
                  Thanks for your inquiry! We're working on your quote and will get back to you soon.
                </h3>
                <div className='explore-section'>
                  <h4 className={'explore-title'}>
                    While you wait, explore our other amazing products!
                  </h4>
                  <div className='action-bar center full'>
                    <Button
                        className={'solid primary pill'}
                        onClick={handleRedirectToProducts}
                    >
                      Browse Our Products
                      <ShoppingBagIcon className={'heroicon-24'}/>
                    </Button>
                  </div>
                </div>
              </div>
          )}
        </section>
      </>
  );
};

export default GetAQuoteProduct;
